import {
    IMeasureType,
    IMetricBatchEvaluationMultipleMetricResult,
    IMetricEvaluateMultipleMetricRequest,
} from "@src/types/ab-testing-exploration";
import { useBaseEvaluateMetric } from "./use-base-evaluate";

type AbExplorationEvaluateMetricProps = {
    baseGroup: string;
    variantGroups: string[];
    metricType?: IMeasureType;
    significanceLevel: number;
    data: any;
    refineOptions?: {
        dataProviderName?: string;
    };
    batch?: boolean;
    isSkip?: boolean;
};

export const useAbExplorationEvaluateMultipleMetric = ({
    baseGroup,
    variantGroups,
    metricType,
    significanceLevel,
    data,
    refineOptions,
    batch = false,
    isSkip = false,
}: AbExplorationEvaluateMetricProps) => {
    const requestPayload: IMetricEvaluateMultipleMetricRequest = {
        base_group: baseGroup,
        variant_groups: variantGroups,
        significance_level: significanceLevel,
        data,
    };

    const apiEndPoint = batch ? "/batch-multiple-metrics" : "";
    const { isLoading, httpError, refetch, result } = useBaseEvaluateMetric<IMetricBatchEvaluationMultipleMetricResult>(
        {
            metricType,
            requestPayload,
            apiEndPoint,
            isSkip,
            refineOptions,
        },
    );

    return {
        isLoading,
        result,
        httpError,
        refetch,
    };
};
